import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {TeamContainerModel} from '../../../../../models/aggregates/team';


@Injectable({
  providedIn: 'root'
})
export class TeamService extends BaseApiTemplateService<TeamContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'teams';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'teams';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'teams';
    this.httpClient = http;
  }
}
